import { namePartsFromUser } from "../../utils/adminUserFormat.js";

function norm(s) {
  return String(s ?? "").trim();
}

function normEmail(s) {
  return norm(s).toLowerCase();
}

/**
 * @param {{ firstName: string, lastName: string, email: string, isAdmin: boolean, status: string }} draft
 * @param {{ firstName: string, lastName: string, email: string, isAdmin: boolean, status: string }} baseline
 */
export function buildPatch(draft, baseline) {
  /** @type {Record<string, unknown>} */
  const patch = {};

  if (norm(draft.firstName) !== norm(baseline.firstName) || norm(draft.lastName) !== norm(baseline.lastName)) {
    patch.name = {
      first: norm(draft.firstName),
      last: norm(draft.lastName),
    };
  }
  if (normEmail(draft.email) !== normEmail(baseline.email)) {
    patch.email = normEmail(draft.email);
  }
  if (Boolean(draft.isAdmin) !== Boolean(baseline.isAdmin)) {
    patch.is_admin = Boolean(draft.isAdmin);
  }
  if (norm(draft.status) !== norm(baseline.status)) {
    patch.status = norm(draft.status);
  }

  return patch;
}

/**
 * @param {{ firstName: string, lastName: string, email: string, isAdmin: boolean, status: string }} draft
 * @param {{ firstName: string, lastName: string, email: string, isAdmin: boolean, status: string }} baseline
 */
export function isDraftDirty(draft, baseline) {
  return Object.keys(buildPatch(draft, baseline)).length > 0;
}

/** @param {{ name?: { first?: string, last?: string }, email?: string, is_admin?: boolean, status?: string }} user */
export function draftFromUser(user) {
  const { first, last } = namePartsFromUser(user);
  return {
    firstName: first != null ? String(first) : "",
    lastName: last != null ? String(last) : "",
    email: user?.email != null ? String(user.email) : "",
    isAdmin: Boolean(user?.is_admin),
    status: String(user?.status || "active"),
  };
}
